export const DISMISS_ACTIVATE_ACCOUNT = 'dismiss-activate-account';
const dismissActivateAccount = () => ({ type: DISMISS_ACTIVATE_ACCOUNT });
export default dismissActivateAccount;
